/**
 * Chat Pattern Extractor
 *
 * This script handles extracting and removing different pattern formats from chat messages:
 * - [TAG:content] format (like [SUGGESTIONS: option1, option2])
 * - [TAG]content[TAG] format (like [WeddingPlan]json[WeddingPlan])
 * - [TAG] format (like [SHOW_DATE_PICKER])
 */

/**
 * Extract values from different pattern types in a string
 * @param {string} text - Input text containing patterns
 * @return {object} - Object with pattern names as keys and extracted content as values
 */
export const extractPatterns = (text) => {
  const result = {};

  // Extract [SUGGESTIONS:content] pattern
  const suggestionsMatch = text?.match(/\[SUGGESTIONS:(.*?)\]/);
  if (suggestionsMatch) {
    result.SUGGESTIONS = suggestionsMatch[1].trim();
  }

  // Extract [WeddingPlan]content[WeddingPlan] pattern
  const weddingPlanMatch = text?.match(
    /\[WeddingPlan\]([\s\S]*?)\[WeddingPlan\]/
  );
  if (weddingPlanMatch) {
    result.WeddingPlan = weddingPlanMatch[1].trim();
  }

  // Extract [SHOW_DATE_PICKER] standalone tag
  if (text?.includes("[SHOW_DATE_PICKER]")) {
    result.SHOW_DATE_PICKER = true;
  }

  return result;
};

/**
 * Remove all patterns from text
 * @param {string} text - Input text containing patterns
 * @return {string} - Cleaned text with all patterns removed
 */
export const cleanText = (text) => {
  let cleaned = text;

  // Remove [SUGGESTIONS:content] pattern
  cleaned = cleaned?.replace(/\[SUGGESTIONS:.*?\]/g, "");

  // Remove [WeddingPlan]content[WeddingPlan] pattern
  cleaned = cleaned?.replace(/\[WeddingPlan\][\s\S]*?\[WeddingPlan\]/g, "");

  // Remove [WeddingPlan] without closing tag and everything after it
  cleaned = cleaned?.replace(/\[WeddingPlan\][\s\S]*$/g, "");

  // Remove [SHOW_DATE_PICKER] tag
  cleaned = cleaned?.replace(/\[SHOW_DATE_PICKER\]/g, "");

  return cleaned;
};

export const parseSuggestions = (text) => {
  return text?.split("; ").map((s) => s.trim());
};

export const parseWeddingPlan = (text) => {
  try {
    return JSON.parse(text);
  } catch (error) {
    console.error("Error parsing wedding plan:", error);
    return null;
  }
};
